import { FormControl} from '@angular/forms';
import { ReplyType } from 'src/app/libs/proto/forum_pb';

export class NewPostForm {
  message: string;
  replytypesList: ReplyType[];
  topicid: string;
}
